import React from 'react'

import { useTranslation } from 'react-i18next'
import { useFetcher } from 'react-router-dom'

import Button from '@components/shared/Button'
import LoadingSpinner, { SpinnerSize } from '@components/shared/LoadingSpinner'
import Score from '@models/Score'
import { useSelection } from '@providers/SelectionProvider'

const RemoveSharedScoreButton: React.FC = () => {
  const { t } = useTranslation()

  const fetcher = useFetcher()
  const { selectedItems } = useSelection<Score>()

  /** Whether the fetcher is submitting or loading data after a delete request */
  const isSubmitting = ['submitting', 'loading'].includes(fetcher.state)

  return (
    <>
      <fetcher.Form method="post" action="/home/removeSharedScores">
        <Button
          name="scoreIds"
          value={selectedItems.map((item) => item.id)}
          variant="outline"
          type="submit"
          size="sm"
          disabled={!selectedItems.length || isSubmitting}
          className="font-medium ml-6 flex flex-row items-center">
          {isSubmitting ? (
            <>
              <LoadingSpinner size={SpinnerSize.SMALL} />
              <span className="ml-1">{t('messages.removing')}</span>
            </>
          ) : (
            <span>{t('action.remove')}</span>
          )}
        </Button>
      </fetcher.Form>
    </>
  )
}

export default RemoveSharedScoreButton
